import type React from "react";
import { useTranslation } from "react-i18next";

import { Spinner } from "@krea/shared/design-system/Spinner";

import type { IFIIdentityProvider } from "../types";
import { BankSelector } from "./BankSelector";

interface BankSelectionFlowProps {
  banks: IFIIdentityProvider[];
  onSelect: (ftnIdpId: string) => void;
  isLoading?: boolean;
}

export const BankSelectionFlow: React.FC<BankSelectionFlowProps> = ({
  banks,
  onSelect,
  isLoading = false,
}) => {
  const { t } = useTranslation();

  if (isLoading || banks.length === 0) {
    return (
      <div className="flex flex-col items-center p-6">
        <Spinner className="text-primary" />
      </div>
    );
  }

  return (
    <div className="w-full" style={{ maxWidth: 800 }}>
      <h6 className="mb-6 text-center text-section">
        {t("bankID.FI.selectBank")}
      </h6>
      <BankSelector banks={banks} onSelect={onSelect} className="w-full" />
    </div>
  );
};
